import React, { useEffect } from "react";

const MAP_URL =
  "https://www.google.com/maps?q=169,+Habibullah+Rd,+Bharathy+Nagar,+T.+Nagar,+Chennai,+Tamil+Nadu+600017&output=embed";

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="cs-google_map mt-4">
      <iframe
        title="Charles Technologies Location"
        src={MAP_URL}
        width="100%"
        height="100%"
        aria-hidden="false"
      ></iframe>
    </div>
  );
}
